/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Completion_Note_RequiredInputs */

const en_api_error_task_completion_note_required = /** @type {(inputs: Api_Error_Task_Completion_Note_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The selected solution requires a completion note.`)
};

const pt_br2_api_error_task_completion_note_required = /** @type {(inputs: Api_Error_Task_Completion_Note_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A solução selecionada exige uma observação de conclusão.`)
};

/**
* | output |
* | --- |
* | "The selected solution requires a completion note." |
*
* @param {Api_Error_Task_Completion_Note_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_completion_note_required = /** @type {((inputs?: Api_Error_Task_Completion_Note_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Completion_Note_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_completion_note_required(inputs)
	return pt_br2_api_error_task_completion_note_required(inputs)
});